module.exports = __webpack_public_path__ + "img/case10.c8927a74.jpg";